module.exports = __webpack_public_path__ + "img/hand-holding-medical.71095a60.svg";